// extracted by mini-css-extract-plugin
module.exports = {"responsiveMaxWidth":"styles--responsiveMaxWidth--QG6cZ"};